<template>
  <div class="customizer-border-style">
    <label>Style</label>
    <select class="form-control" v-model="borderStyle">
      <option v-for="style in borderStyles" :key="style" :value="style">{{style | upperFirst}}</option>
    </select>
  </div>
</template>

<script>
import filters from '@/mixins/filters'
import mapMultiComputed from '@/mixins/mapMultiComputed'

export default {
  mixins: [
    mapMultiComputed('amptheme', [ 'borderStyle' ], true),
    filters
  ],
  props: {
    category: String
  },
  computed: {
    borderStyles: function () {
      return [ 'solid', 'dashed', 'dotted', 'double', 'groove', 'hidden', 'ridge' ]
    }
  }
}
</script>
